import { yenToPoints } from "@roman/shared/utils/pointsToYen";
import type { CardQuantity } from ".";

export const COMMISSION_PERCENTAGE = 10;

export const calculateTotalYenWithCommission = (cardQuantities: CardQuantity[]) => {
  const subtotal = cardQuantities.reduce((acc, { yenOption, quantity }) => acc + Number(yenOption) * quantity, 0);
  return subtotal * ((100 + COMMISSION_PERCENTAGE) / 100);
};

export const calculateTotalPointsWithCommission = (cardQuantities: CardQuantity[]) => {
  return yenToPoints(calculateTotalYenWithCommission(cardQuantities));
};

export const calculateTotalPointsForRequest = (totalConsumingPoints: number) => {
  return (totalConsumingPoints * 100) / (100 + COMMISSION_PERCENTAGE);
};

export const calculateTotalYen = (cardQuantities: CardQuantity[]) => {
  return cardQuantities.reduce((acc, { yenOption, quantity }) => acc + Number(yenOption) * quantity, 0);
};
